import { formatDistanceToNowStrict } from 'date-fns';

export const getRelativeTimeAgo = (pastDate: Date): string =>
  formatDistanceToNowStrict(pastDate, { addSuffix: true });
